$(document).ready(function () {
  
//Increment + decrement 
  
  $('#adds').click(function add() {
    var $rooms = $("#noOfRoom");
    var a = $rooms.val();
    a++;
    $("#subs").prop("disabled", !a);
    $rooms.val(a);
});
// Set initial disabled state
$("#subs").prop("disabled", !$("#noOfRoom").val());

$('#subs').click(function subst() {
    var $rooms = $("#noOfRoom");
    var b = $rooms.val();
    if (b >= 1) {
        b--;
        $rooms.val(b);
    }
    else {
        $("#subs").prop("disabled", true);
    }
});
  
  /*----------------------------------/
    
///Switch Board //    
$( ".swatch-element" ).click(function() {
    // Get all matched element
    if(variant.compare_at_price > 0.0) {
      console.log("true");
  } else {
      console.log("false");
  } 
});
/*------------------ TAB JS ----------*/
// text-btn
$(".text-btn").on('click', function() {

  $('.engrave-text-cont').show();
  $('.engrave-text-switch-cont').show();
  $('.maps-latitude, .maps-longitude').remove();
  $(".text-btn").addClass("active-switcher");
  $(".coords-btn").removeClass("active-switcher");
  if ($('.engrave-text-switch-cont').children().length == 0) {
    $('.engrave-text-switch-cont').append('<div class="line-item-property__field text-engrave"><label for="text-engrave">Engrave Text</label><input id="text-engrave" maxlength="22" type="text" name="properties[Text]" placeholder="Insert your text"></div>');
    $('.special-input').hide();
    $('.maps-input-label').hide();
    $('.special-group-display').hide();
    $('.special-group-hide').hide();
  }
});
//coords-btn
$(".coords-btn").on('click', function() {
  $('.engrave-text-switch-cont').hide();
  $('.engrave-text-cont').hide();
  $('.special-group-hide').show();
  $('.special-input').show();
  $('.maps-input-label').show();
  $('.special-group-display').show();
  $(".text-btn").removeClass("active-switcher");
  $(".coords-btn").addClass("active-switcher");
  if ($('.input-container-switch').children().length == 0) {
    $('.input-container-switch').append('<div class="line-item-property__field maps-latitude"><input id="latitude" maxlength="14" type="text" name="properties[Latitude]" value="' + localStorage.getItem("cuffCoordinatesLatitude") + '"></div><div class="line-item-property__field maps-longitude"><input id="longtitude" maxlength="14" type="text" name="properties[Longitude]" value="' + localStorage.getItem("cuffCoordinatesLongitude") + '"></div>');
    $('.text-engrave').remove();
  }
});
  
  
  
///Setup Default  
localStorage.setItem("cuffCoordinatesLongitude", '55.9634° N');
localStorage.setItem("cuffCoordinatesLatitude", '10.0463° E');
// For Coordinates
      $( ".coords-btn" ).click(function() {
        $('.engrave-text-switch-cont').hide();
        $('.engrave-text-cont').hide();
        $('.special-group-hide').show();
        $('.special-input').show();
        $('.maps-input-label').show();
          	$('.special-group-display').show();
        $( ".text-btn").removeClass("active-switcher");
        $( ".coords-btn").addClass("active-switcher");
        if ( $('.input-container-switch').children().length == 0 ) {
     
          $('.input-container-switch').append('<div class="line-item-property__field maps-latitude"><input id="latitude" maxlength="14" type="text" name="properties[Latitude]" value="' + localStorage.getItem("cuffCoordinatesLatitude") + '"></div><div class="line-item-property__field maps-longitude"><input id="longtitude" maxlength="14" type="text" name="properties[Longitude]" value="' + localStorage.getItem("cuffCoordinatesLongitude") + '"></div>');
        	$('.text-engrave').remove();
        }

    });
// For Custom TEXT    
$( ".text-btn" ).click(function() {
     $('.engrave-text-cont').show();
     $('.engrave-text-switch-cont').show();
     $('.maps-latitude, .maps-longitude').remove();
     $( ".text-btn").addClass("active-switcher");
        $( ".coords-btn").removeClass("active-switcher");
        if ( $('.engrave-text-switch-cont').children().length == 0 ) {
     		$('.engrave-text-switch-cont').append('<div class="line-item-property__field text-engrave"><label for="text-engrave">Engrave Text</label><input id="text-engrave" maxlength="22" type="text" name="properties[Text]" placeholder="Insert your text"></div>');
			$('.special-input').hide();
          $('.maps-input-label').hide();
          	$('.special-group-display').hide();
          	$('.special-group-hide').hide();
        }
     });
});
/*-----------------------MAP JS -----*/

        mapboxgl.accessToken = 'pk.eyJ1IjoibmVldHUwMDciLCJhIjoiY2tja285NGhsMXhoNTJ0bngyMmRid2c4bCJ9.mYlf83S-rNRT76nbKj32Zw';
	var map = new mapboxgl.Map({
	  container: 'map',
	  style: 'mapbox://styles/mapbox/light-v10',
	  center: [55.9634, 10.0463],
	  zoom: 1
	});
        const geolocate = new mapboxgl.GeolocateControl({
	  positionOptions: {
	    enableHighAccuracy: true
	  },
	  trackUserLocation: true
	});
	map.addControl(geolocate);

	map.on('load', function() {
	  $("#map").css("pointer-events", "auto");
	   // geocoder.query('Denmark');
	  });

	geolocate.on('geolocate', function() {

	  //Get the updated user location, this returns a javascript object.
	  var userlocation = geolocate._lastKnownPosition;

	  var lat = userlocation.coords.latitude;
	  var lng = userlocation.coords.longitude;
    
        console.log('on geolocate', lat, lng)
	  updateCoordinateInputs(lat, lng)

	
    });

	function findLocation() {
	  document.querySelector('.mapboxgl-ctrl-geocoder--input').id = 'mapbox-search';
	  document.querySelector('.suggestions').id = 'suggestionsBox';
	  geocoder.query(document.getElementById("mapbox-search").value);
	  document.getElementById("suggestionsBox").style.display = 'none';
	}

	var checkbox = document.getElementById("map-lock-input");

	checkbox.addEventListener('change', function() {
	  if (this.checked) {
	    $("#map").css("pointer-events", "auto");
	  } else {
	    $("#map").css("pointer-events", "none");
	  }
	});



	var geocoder = new MapboxGeocoder({
	  accessToken: mapboxgl.accessToken,
	  mode: 'mapbox.places', // does not provide POI data   // mode: 'mapbox.places-permanent', 
	  mapboxgl: mapboxgl,
          placeholder: 'Find your special place' //Denmark
	});


	geocoder.on('result', function(ev) {
	  var latString = ev.result.geometry.coordinates[1];
	  var lngString = ev.result.geometry.coordinates[0];
	  $('.mapboxgl-ctrl-geocoder--input').blur();

	  var lat = JSON.stringify(latString);
	  var lng = JSON.stringify(lngString);
         console.log('on geocode result', lat, lng)
	      updateCoordinateInputs(lat, lng)
      
      if (lat == '55.9634' && lng == '10.0463' ) {
        $(".mapboxgl-ctrl-geocoder--input").attr('placeholder', 'Find your special place');
      } else {
        $(".mapboxgl-ctrl-geocoder--input").attr('placeholder', 'Find your special place');
      }
	});


	$( window ).on( "load", function() {
           $('.mapboxgl-ctrl-geocoder--input').val('');
        });
	map.on('click', function(e) {
	  var lat = JSON.stringify(e.lngLat.lat);
	  var lng = JSON.stringify(e.lngLat.lng);
          console.log('on map click', lat, lng)
	  if (geocoder.mapMarker) {
	    geocoder.mapMarker.setLngLat(e.lngLat);
	    updateCoordinateInputs(lat, lng)
	  } else {
	    var marker = new mapboxgl.Marker()
	      .setLngLat(e.lngLat)
	      .addTo(map);
	    geocoder.mapMarker = marker
	    updateCoordinateInputs(lat, lng)
	  }

	});

    function _convertDDToDMS(coordinate) {
	  var absolute = Math.abs(coordinate);
	  var degrees = Math.floor(absolute);
	  var minutesNotTruncated = (absolute - degrees) * 60;
	  var minutes = Math.floor(minutesNotTruncated);
	  var seconds = Math.round((minutesNotTruncated - minutes) * 60 * 100) / 100;
	  if (coordinate < 0) degrees *= -1;
	  return degrees + "°" + minutes + "'" + seconds.toFixed(2);
	}

	function convertDDToDMS(lat, lng) {
	  lat = Number(String(lat).replace(/° \w/, ""))
	  lng = Number(String(lng).replace(/° \w/, ""))
	  var latitude = _convertDDToDMS(lat);
	  var latitudeCardinal = lat > 0 ? "''N" : "''S";

	  var longitude = _convertDDToDMS(lng);
	  var longitudeCardinal = lng > 0 ? "''E" : "''W";

	  return {
	    latitude: latitude + latitudeCardinal,
	    longtitude: longitude + longitudeCardinal
	  }
	}


	function _convertDMSToDD(degrees, minutes, seconds, direction) {
	  let dd = Number(degrees) + Number(minutes) / 60 + Number(seconds) / 3600;

	  if (direction == "S" || direction == "W") {
	    dd = dd * -1;
	  } // Don't do anything for N or E
	  return dd.toFixed(4) + "° " + (direction);
	}

	function convertDMSToDD(lat, lng) {
	  let latParts = lat.match(/(\d+)°(\d+)'(\d+\.?\d*)''(\w)/)
	  let longParts = lng.match(/(\d+)°(\d+)'(\d+\.?\d*)''(\w)/)
	  let latitude = _convertDMSToDD(latParts[1], latParts[2], latParts[3], latParts[4])
	  let longtitude = _convertDMSToDD(longParts[1], longParts[2], longParts[3], longParts[4])
	  return {
	    latitude: latitude,
	    longtitude: longtitude
	  }
	}

	function updateCoordinateInputs(lat, lng) {

	  if (lat > 0) {
	    lat = parseFloat(lat).toFixed(4) + "° N";
	  } else {
	    lat = parseFloat(lat).toFixed(4) + "° S";
	  }
	  if (lng > 0) {
	    lng = parseFloat(lng).toFixed(4) + "° E";
	  } else {
	    lng = parseFloat(lng).toFixed(4) + "° W";
	  }

	  localStorage.setItem("cuffCoordinatesLongitude", lng);
	  localStorage.setItem("cuffCoordinatesLatitude", lat);
    
	  if ($("#dmstoggler").is(":checked")) {
	    let dms = convertDDToDMS(lat, lng)
	    lat = dms.latitude
	    lng = dms.longtitude
	  }
	  document.getElementById('latitude').value = lat;
	  document.getElementById('longtitude').value = lng;
	}
  
  function localStorageGetLng() {
  	let lng = localStorage.getItem("cuffCoordinatesLongitude");
    if ($("#dmstoggler").is(":checked")) {
	    lng = convertDDToDMS(0, lng).longtitude
	  }
    return lng
  }
  
  function localStorageGetLat() {
  	let lat = localStorage.getItem("cuffCoordinatesLatitude");
    if ($("#dmstoggler").is(":checked")) {
	    lat = convertDDToDMS(lat, 0).latitude
	  }
    return lat
  }

	$("#dmstoggler").on('change', function(eventInfo) {
	  let longInput = document.getElementById("longtitude")
	  let latInput = document.getElementById("latitude")

	  if (eventInfo.target.checked) {
	    // convert to DMS
	    let dms = convertDDToDMS(latInput.value, longInput.value)
	    latInput.value = dms.latitude;
	    longInput.value = dms.longtitude;
              localStorage.setItem("cuffCoordinatesLongitude", dms.longtitude);
	  localStorage.setItem("cuffCoordinatesLatitude", dms.latitude);
	  } else {
	    // convert back to decimal degrees
	    let dd = convertDMSToDD(latInput.value, longInput.value)
	    latInput.value = dd.latitude
	    longInput.value = dd.longtitude
        localStorage.setItem("cuffCoordinatesLongitude", dd.longtitude);
	  localStorage.setItem("cuffCoordinatesLatitude", dd.latitude);
	  }
	  $("#dmstoggler_state").html(eventInfo.target.checked ? "DMS" : "Decimal degrees")
	})

	map.addControl(new mapboxgl.NavigationControl());
	document.getElementById('geocoder').appendChild(geocoder.onAdd(map));



